// export const BASE_URL = 'http://127.0.0.1:8000';
// export const _BASE_URL = 'http://127.0.0.1:8000/';
export const BASE_URL = 'https://khabir.etmaan.org/backend/public';
export const _BASE_URL = 'https://khabir.etmaan.org/backend/public/';
export const IMAGE_URL = 'https://khabir.etmaan.org/backend/';

export const MAP_API_KEY = 'AIzaSyArXf_fv4G3ywxs4Az_apQlvFiKY95Yz-4';